import { render, staticRenderFns } from "./checkpay.vue?vue&type=template&id=0281a32a&scoped=true&"
import script from "./checkpay.vue?vue&type=script&lang=js&"
export * from "./checkpay.vue?vue&type=script&lang=js&"
import style0 from "./checkpay.vue?vue&type=style&index=0&id=0281a32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281a32a",
  null
  
)

export default component.exports